import CarrierRevenueCell from './container';

export default CarrierRevenueCell;
